import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const coursesSlice = createSlice({
    name: 'courses',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateCourse: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setCourses: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setCourse: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setCourseMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setCourseError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getCoursesThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/courses`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setCourses(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setCourseError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getCourseThunk = (Course_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/courses/${Course_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setCourse(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setCourseError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createCourseThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/courses/createCourse`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setCourseMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setCourseError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateCourseThunk = (Course_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/courses/updateCourse/${Course_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setCourseMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setCourseError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteCourseThunk = (Course_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/courses/${Course_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setCourseMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setCourseError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateCourse,
    setCourses,
    setCourse,
    setCourseMessages,
    setCourseError
} = coursesSlice.actions;

export default coursesSlice.reducer;